import 'babel-polyfill';
import * as React from 'react';
import Spinner from '../../common/components/spinner/spinner';
import Translate from '../../common/functions/translate';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import Growl from '../../common/components/alertMessage/growl';
import 'leaflet/dist/leaflet.css'
import L from 'leaflet';
import GoogleMapReact from 'google-map-react';
import Paper from '@material-ui/core/Paper';
import * as Constants from '../../common/constants';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import MyLocation from '@material-ui/icons/MyLocation';
import { DisposalPlacesModel } from '../../models/user/disposalPlaces';
import DisposalPlacesService from '../../services/disposalPlacesService';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export const suitcasePoint = new L.Icon({
  iconUrl: require('../../assets/images/icons/markers/location-icon-transparent-background-1.jpg'),
  iconRetinaUrl: require('../../assets/images/icons/markers/location-icon-transparent-background-1.jpg'),
  iconAnchor: [20, 40],
  popupAnchor: [0, -35],
  iconSize: [30, 45],
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  shadowSize: [29, 40],
  shadowAnchor: [12, 40],
})

// const AnyReactComponent = ({ lat, lng, text }) => (
//   <div style={{
//     color: 'white',
//     background: 'grey',
//     padding: '15px 10px',
//     display: 'inline-flex',
//     textAlign: 'center',
//     alignItems: 'center',
//     justifyContent: 'center',
//     borderRadius: '100%',
//     transform: 'translate(-50%, -50%)'
//   }}>
//     {text}
//   </div>
// );

interface IProps {
  onLangChange: any,
  lang: string,
}

interface IState {
  error: any,
  isLoading: boolean,
  longitude: number,
  latitude: number,
  disposalPlaces: Array<DisposalPlacesModel>,
  selectedDisposalPlace: Array<number>,
  searchedString: string
}

class DisposalPlacesContainer extends React.Component<IProps, IState> {
  growl: any;
  disposalPlacesService = new DisposalPlacesService(this.props.lang);
  mymap: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      isLoading: false,
      longitude: 0,
      latitude: 0,
      disposalPlaces: new Array<DisposalPlacesModel>(0),
      selectedDisposalPlace: new Array<number>(0),
      searchedString: ''
    }
  }

  componentDidMount() {
    this.getLocation();
    this.getDisposals(true);
  }

  getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition);
      this.mymap.leafletElement.setView([this.state.latitude, this.state.longitude], 12);
    } else {
      console.log("Geo Location not supported by browser");
    }
  }

  //function that retrieves the position
  showPosition = (position) => {
    var location = {
      longitude: position.coords.longitude,
      latitude: position.coords.latitude
    }

    if (location) {
      this.setState({ longitude: location.longitude, latitude: location.latitude });
    }
  }

  getDisposals = (fromFilter: boolean) => {
    this.setState({ isLoading: true });
    let searchedString: string = '';
    if (this.state.searchedString && this.state.searchedString.trim() != '') {
      searchedString = this.state.searchedString.trim();
    }
    this.disposalPlacesService.getAllDisposalPlaces(searchedString).then(
      (data: Array<DisposalPlacesModel>) => {
        if (data) {

          if (data && data.length > 0) {
            let minLat = data[0].latitude;
            let maxLat = data[0].latitude;
            let minLong = data[0].longtitude;
            let maxLong = data[0].longtitude;

            data.map(place => {
              maxLat = place.latitude > maxLat ? place.latitude : maxLat;
              minLat = place.latitude < minLat ? place.latitude : minLat;
              maxLong = place.longtitude > maxLong ? place.longtitude : maxLong;
              minLong = place.longtitude < minLong ? place.longtitude : minLong;
            })

            if (fromFilter) {
              if (data.length > 1 && (minLat != maxLat || minLong != maxLong)) {
                this.mymap.leafletElement.fitBounds([[minLat, maxLong], [maxLat, minLong]]);
                this.setState({
                  isLoading: false,
                  disposalPlaces: data
                });
              }
              else {
                this.mymap.leafletElement.setView([data[0].latitude, data[0].longtitude], 15);
                this.setState({
                  isLoading: false,
                  disposalPlaces: data
                });
              }
            } else {
              this.setState({
                isLoading: false,
                disposalPlaces: data
              });
            }
          } else {
            this.setState({
              isLoading: false,
              disposalPlaces: data
            });
          }
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleDropdownChange = (value) => {
    this.mymap.leafletElement.setView(value, 15);
    this.setState({ selectedDisposalPlace: value });
  }

  handleSearch = (e) => {
    this.setState({ searchedString: e });
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchButtonClick();
    }
  }

  handleSearchButtonClick = () => {
    this.getDisposals(true);
    //this.setState({ mapZoom: 7, selectedDisposalPlace: [...this.state.mapCenter] }, () => this.getDisposals(true));
  }

  myPositionClick = () => {
    this.mymap.leafletElement.setView([this.state.latitude, this.state.longitude], 15);
  }

  public render() {

    const { isLoading, latitude, longitude, selectedDisposalPlace, disposalPlaces } = this.state;
    let mapCenter: Array<number> = [];
    mapCenter = [this.state.latitude, this.state.longitude];
    let position = [this.state.latitude, this.state.longitude];
    if (selectedDisposalPlace && selectedDisposalPlace.length > 0) {
      mapCenter = selectedDisposalPlace;
    }

    return (
      <div className="app-content">

        {isLoading ? <Spinner /> : null}
        <Growl ref={(el) => this.growl = el} />

        <h2>{Translate('DisposalPlaces')}</h2>

        <div className="disposal-places-container">
          <div className="disposal-places-map">
            <Map ref={(el) => this.mymap = el}>
              <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {this.state.latitude != 0 && this.state.longitude != 0 ?
                <Marker icon={suitcasePoint} position={position}>
                  <Popup>
                    {Translate('Your location')}
                  </Popup>
                </Marker> : null}
              {this.state.disposalPlaces && this.state.disposalPlaces.length > 0 ? this.state.disposalPlaces.map(p =>
                <Marker key={p.disposalPlaceId} position={[p.latitude, p.longtitude]}>
                  <Popup>
                    {p.city ? p.city + ', ' : ''}
                    {p.region ? p.region + ', ' : ''}
                    {p.address ? p.address + ', ' : ''}
                    {p.date ? HelperFunctions.fomatDateAsStringWithLang(new Date(p.date), this.props.lang) + ', ' : ''}
                    {p.interval ? p.interval : ''}<br />
                    {p.description ? p.description : ''}
                  </Popup>
                </Marker>) : null}
            </Map>
          </div>
          <div className="disposal-places-list">
            <div style={{ marginBottom: 10, flexFlow: 'row wrap', display: 'flex' }}>
              <div style={{ boxSizing: 'border-box', minWidth: '85%', maxWidth: '85%' }}>
                <h3>{Translate('Search')}</h3>
                <Paper style={Constants.inputWithButton.root} elevation={1}>
                  <InputBase style={Constants.inputWithButton.input} placeholder={Translate('EnterAddressOrCity')}
                    onChange={(e) => this.handleSearch(e.target['value'])}
                    onKeyPress={this.handleKeyPress}
                    value={this.state.searchedString ? this.state.searchedString : ""}
                  />
                  <IconButton
                    color="primary"
                    style={Constants.inputWithButton.iconButton}
                    onClick={this.handleSearchButtonClick}
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
              </div>
              <div style={{ boxSizing: 'border-box', paddingTop: '36px', maxWidth: '15%' }}>
                {this.state.latitude != 0 && this.state.longitude != 0 ?
                  <IconButton
                    color="primary"
                    style={Constants.inputWithButton.iconButton}
                    onClick={this.myPositionClick}
                  > <MyLocation></MyLocation>
                  </IconButton> : null}
              </div>
            </div>
            <ul className="list-items disposal-places-list-items" id="map-info-scrollbar">
              {this.state.disposalPlaces.map((m: DisposalPlacesModel) =>
                <li style={{ borderTop: 'none', paddingLeft: 5 }} key={m.disposalPlaceId + 'dispId'}>
                  <div className="item-info" onClick={() => this.handleDropdownChange([m.latitude, m.longtitude])}>
                    <div className="item-name">
                      {m.city ? m.city + ', ' : ''}
                      {m.region ? m.region + ', ' : ''}
                      {m.address ? m.address : ''}
                      <div>
                        {m.date ? HelperFunctions.fomatDateAsStringWithLang(new Date(m.date), this.props.lang) + ', ' : ''}
                        {m.interval ? m.interval : ''}
                      </div>
                    </div>
                    <div className="item-desc">
                      {m.description ? m.description : ''}
                    </div>
                  </div>
                  <div className="item-actions" onClick={() => this.handleDropdownChange([m.latitude, m.longtitude])}>
                    <FontAwesomeIcon icon={faMapMarkedAlt} />
                  </div>
                </li>)}
            </ul>
          </div>
          {/* <div style={{ height: '400px', width: '100%' }}>
            <GoogleMapReact
              bootstrapURLKeys={{ key: 'AIzaSyDzufYRK20144dhhGTx3zCVUz9RdNsMn3Y' }}
              defaultCenter={position}
              defaultZoom={13}
              yesIWantToUseGoogleMapApiInternals
            >
              <AnyReactComponent lat={latitude}
                lng={longitude} text={'asdasd'}></AnyReactComponent>
            </GoogleMapReact>
          </div> */}
        </div>

      </div>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps, null)(DisposalPlacesContainer);